export default __webpack_public_path__ + "static/media/III 2025.6a5ea445.pdf";